import React from 'react';
import cn from 'classnames';

import { LINE_ITEM_PRICE_MODEL } from 'common/enums/lineItemPriceModel';

import { ToggleControl } from 'components/Controls';

import { CELL_TYPES } from '../../enums';
import { useLineItemField, useLineItemSelector } from '../../context';
import Cell from '../Cell';

import LocationPricing from './locationPricing';
import styles from './line.module.css';

const LocationLine = ({ disabledState, lockedState }) => {
  const getFlagValue = useLineItemField('getFlagValue');

  const uuid = useLineItemField('uuid');

  const quantityType = useLineItemSelector(({ cellTypes }) => cellTypes['quantity']);

  const isPriceModelRecurring = useLineItemSelector(
    ({ priceModelSelected }) => priceModelSelected === LINE_ITEM_PRICE_MODEL.RECURRING
  );
  const priceModelSelectedEditable = useLineItemField('priceModelSelectedEditable');

  const hasError = useLineItemField('hasError');

  const hideCount = getFlagValue('hideCount') === 'TRUE';

  return (
    <tr>
      <Cell type={CELL_TYPES.label} alias="lineItemName" className={cn({ [styles.hasError]: hasError })} />
      <Cell type={hideCount ? CELL_TYPES.null : CELL_TYPES.label} alias="totalQuantity" className={styles.quantity} />
      <Cell type={hideCount ? CELL_TYPES.null : CELL_TYPES.label} alias="available" className={styles.quantity} />
      <Cell
        type={hideCount ? CELL_TYPES.null : lockedState ? CELL_TYPES.label : quantityType}
        alias="quantity"
        className={styles.quantity}
        disabled={disabledState}
        locked={lockedState}
      />
      <LocationPricing active={!isPriceModelRecurring} adjusted="upfrontAdjusted" extended="upfrontExtended" />
      <td className={styles.priceModel}>
        <ToggleControl
          className={styles.toggle}
          id={`line-item-toggle-${uuid}`}
          msgOn={priceModelSelectedEditable ? 'msg_rent' : 'msg_recurring_cost_short'}
          msgOff="msg_buy"
          value={isPriceModelRecurring}
          disabledState
        />
      </td>
      <LocationPricing active={isPriceModelRecurring} adjusted="recurringAdjusted" extended="recurringExtended" />
    </tr>
  );
};

export default LocationLine;
